function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import ReactDOM from 'react-dom';
import { getConfig } from '@okee-uikit/react-config';
import { ConfigProvider } from '../config-provider';
import { ImageView } from './ImageView';
export function imageView(props) {
  var container = document.createElement('div');

  var _getConfig = getConfig(),
      locale = _getConfig.locale,
      prefixCls = _getConfig.prefixCls;

  document.body.appendChild(container);

  var handleClose = function handleClose() {
    ReactDOM.unmountComponentAtNode(container);
    document.body.removeChild(container);
  };

  ReactDOM.render(React.createElement(ConfigProvider, {
    locale: locale,
    prefixCls: prefixCls
  }, React.createElement(ImageView, _objectSpread(_objectSpread({}, props), {}, {
    handleClose: handleClose
  }))), container);
}